
const ModalHeader = ({ title, desc } : { title: string, desc: string }) => {
    return <div className="modal-header">
        <span className="title">{title}</span>
        <span className="description">{desc}</span>
    </div>
}

export default ModalHeader;